module.exports = __webpack_public_path__ + "img/download-1-phone.f9d9bc91.png";